const qs = require('qs')
const { showError, showNotifikasi } = require('../libs/helper')

module.exports = {
  updateStatusQr: async (g, data) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/mark-qr-code`,
      method: 'post',
      data: qs.stringify(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
      .then(res => {
        try {
          if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403) { showNotifikasi(g, 'danger', 'Error Get Data', res.data.message) }
        } catch (error) {
          console.log(error)
        }

        return res.data
      })
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
  printQrCode: async (g, data) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/list-qrcode`,
      method: 'post',
      data: qs.stringify(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/octet-stream',
      },
      responseType: 'blob',
    })
      .then(res => {
        try {
          if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403) { showNotifikasi(g, 'danger', 'Error Get Data', res.data.message) }
        } catch (error) {
          console.log(error)
        }

        return res.data
      })
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
}
